// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ecf0b4c9","453":"7d726610","732":"ad87eb73"}[chunkId] + ".chunk.js";
};